var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('h5',[_vm._v("Mapa do Evento")]),_c('v-card',{staticClass:"rounded-lg",attrs:{"outlined":""}},[(_vm.tableMap)?_c('table-selector',{staticClass:"rounded-lg elevation-0",attrs:{"table-map":_vm.tableMap,"party":_vm.party,"loading":_vm.loading,"value":null},on:{"input":_vm.goToTicketGroup}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }